import { Button, DatePicker, Empty, Form, InfiniteScroll, Input, List, NavBar, Popup, Selector, Space, Tag, Toast } from 'antd-mobile';
import { CloseCircleOutline, FilterOutline, RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listAvailableDevice, listDeviceType } from '../componet/service';
import '../styles/BorrowHisPage.css';

const AvailableDevicePage = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterVisible, setFilterVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const pageSize = 20;
    const [clear, setClear] = useState(true);
    const [filter, setFilter] = useState({
        assetNo: '',
        name: null,
        typeId: null
    });
    const [filterConfig, setFilterConfig] = useState(filter);
    const [form] = Form.useForm();
    const [deviceTypes, setDeviceTypes] = useState([]);
    // 根据typeId获取类型名称
    const getTypeNameById = (typeId) => {
        const type = deviceTypes.find(type => type.value === typeId);
        return type ? type.label : typeId;
    };
    const fetchDeviceTypes = async () => {
        try {
            const res = await listDeviceType();
            const typeOptions = res.data.map(type => ({
                label: type.name,
                value: type.id
            }));
            setDeviceTypes(typeOptions);
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '获取设备类型失败'
            });
        }
    };
    // 获取借出记录
    const fetchDeviceRecords = async (pageNum = 1, isLoadMore = false) => {
        if (pageNum === 1) {
            setLoading(true);
        }
        try {
            // 这里替换为实际的API调用
            // const response = await fetchBorrowHistory(filter, pageNum, pageSize);
            const res = await listAvailableDevice(pageNum, pageSize, filter)
            // 模拟数据 - 实际项目中应替换为API调用
            const deviceList = res.data.content;
            // 更新数据和分页状态
            let totalRecords = [...records, ...deviceList];
            setRecords(totalRecords);
            // 判断是否还有更多数据
            setHasMore(res.data.totalCnt > totalRecords.length);
            setPage(pageNum);
            setLoading(false);
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '获取数据失败'
            });
            setLoading(false);
            setHasMore(false);
        }
    };

    useEffect(() => {
        fetchDeviceTypes();
        setRecords([]);
        setPage(1);
        setHasMore(true);
        setClear(true);
    }, [filter]);

    useEffect(() => {
        if (clear) {
            fetchDeviceRecords(1, false);
            setClear(false);
        }
    }, [clear]);

    // 加载更多数据
    const loadMore = async () => {
        if (!hasMore) return;
        const nextPage = page + 1;
        await fetchDeviceRecords(nextPage, true);
    };
    // 应用筛选条件
    const applyFilter = (values) => {
        setFilter({ ...filterConfig });
        setFilterVisible(false);
    };

    // 重置筛选条件
    const resetFilter = () => {
        const emptyFilter = {
            borrowStatus: '',
            borrowStartTime: null,
            borrowEndTime: null
        };
        setFilter(emptyFilter);
        setFilterConfig(emptyFilter);
        form.resetFields();
        setFilterVisible(false);
    };

    return (
        <div className="borrow-history-container">
            <NavBar
                back="返回"
                onBack={() => navigate(-1)}
                right={
                    <FilterOutline
                        fontSize={24}
                        onClick={() => setFilterVisible(true)}
                    />
                }
            >
                可借设备
            </NavBar>

            {/* 筛选条件摘要 */}
            {(filter.assetNo || filter.name || filter.typeId) && (
                <div className="filter-summary">
                    <Space wrap>
                        {filter.assetNo && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, assetNo: '' })}
                            >
                                资产编号: {filter.assetNo}
                            </Tag>
                        )}
                        {filter.name && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, name: null })}
                            >
                                设备名称: {filter.name}
                            </Tag>
                        )}
                        {filter.typeId && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, typeId: null })}
                            >
                                设备类型: {getTypeNameById(filter.typeId)}
                            </Tag>
                        )}
                        <Button
                            size='mini'
                            onClick={resetFilter}
                        >
                            清除全部
                        </Button>
                    </Space>
                </div>
            )}

            {/* 记录列表 */}
            {loading && page === 1 ? (
                <div className="loading-container">加载中...</div>
            ) : records.length > 0 ? (
                <>
                    <List className="borrow-list">
                        {records.map(record => (
                            <List.Item
                                key={record.id}
                                // onClick={() => viewDetail(record)}
                                description={
                                    <div className="item-description">
                                        <div>设备名称: {record.name}</div>
                                        <div>设备型号: {record.model}</div>
                                    </div>
                                }
                            >
                                <div className="item-title">
                                    <span className="asset-no">资产编号：{record.assetNo}</span>
                                </div>
                                <div className="item-title">
                                    <span className="device-type">设备类型：{getTypeNameById(record.typeId)}</span>
                                </div>

                            </List.Item>
                        ))}
                    </List>

                    {/* 无限滚动加载组件 */}
                    <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
                </>
            ) : (
                <Empty
                    className="empty-container"
                    image={<CloseCircleOutline style={{ fontSize: 48 }} />}
                    description="暂无可借设备记录"
                />
            )}

            {/* 筛选弹窗 */}
            <Popup
                visible={filterVisible}
                onMaskClick={() => setFilterVisible(false)}
                position="right"
                bodyStyle={{ width: '80vw' }}
            >
                <div className="filter-container">
                    <NavBar
                        back="取消"
                        onBack={() => setFilterVisible(false)}
                    >
                        筛选条件
                    </NavBar>

                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={applyFilter}
                        footer={
                            <div className="filter-buttons">
                                <Button block onClick={resetFilter}>重置</Button>
                                <Button block type="submit" color="primary">应用</Button>
                            </div>
                        }
                    >
                        <Form.Item name="assetNo">
                            <Input
                                placeholder="请输入资产编号"
                                value={filterConfig.assetNo}
                                onChange={(val) => setFilterConfig({ ...filterConfig, assetNo: val })}
                            />
                        </Form.Item>

                        <Form.Header>设备名称</Form.Header>
                        <Form.Item name="name">
                            <Input
                                placeholder="请输入设备名称"
                                value={filterConfig.name}
                                onChange={(val) => setFilterConfig({ ...filterConfig, name: val })}
                            />
                        </Form.Item>

                        <Form.Header>设备类型</Form.Header>
                        <Form.Item name="typeId">
                            <Selector
                                options={deviceTypes}
                                value={filterConfig.typeId ? [filterConfig.typeId] : []}
                                onChange={(arr) => {
                                    const selectedType = arr.length > 0 ? arr[0] : null;
                                    setFilterConfig({ ...filterConfig, typeId: selectedType });
                                }}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Popup>
        </div>
    );
};

export default AvailableDevicePage;